import AppReducer from "./AppReducer";
import { type } from "./../types/types";

export default function reducer(state, action) {
  switch (action.type) {
    case type.LOGOUT:
      return AppReducer(undefined, action);
    default:
      return AppReducer(state, action);
  }
}
